module.exports = __webpack_public_path__ + "static/media/profile-image.11860f97.svg";